module.exports = __webpack_public_path__ + "img/metal_aj@2x.c7971fd7.png";